import { render, staticRenderFns } from "./CompleteProject.vue?vue&type=template&id=37bc19bc&scoped=true"
import script from "./CompleteProject.vue?vue&type=script&lang=js"
export * from "./CompleteProject.vue?vue&type=script&lang=js"
import style0 from "./CompleteProject.vue?vue&type=style&index=0&id=37bc19bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc19bc",
  null
  
)

export default component.exports